import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_loader = _resolveComponent("loader")!
  const _component_previsione_table = _resolveComponent("previsione-table")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "px-4 px-sm-0" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, { class: "bg-white rounded-lg" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, { class: "mb-8 py-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tabs, {
                modelValue: _ctx.localita,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localita) = $event)),
                  _cache[1] || (_cache[1] = (value) => _ctx.tabChange(value))
                ],
                class: "border-b-sm",
                color: "indigo-darken-1"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localitaTabs, (localita) => {
                    return (_openBlock(), _createBlock(_component_v_tab, {
                      value: localita.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(localita.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 256))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.loading === true)
            ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previsioni, (item) => {
            return (_openBlock(), _createBlock(_component_v_container, { class: "overflow-x-auto" }, {
              default: _withCtx(() => [
                (_ctx.loading !== true)
                  ? (_openBlock(), _createBlock(_component_previsione_table, {
                      key: 0,
                      localita: _ctx.selectedLocalita,
                      previsione: item
                    }, null, 8, ["localita", "previsione"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 256))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}